import { useProfile } from '@hooks/useProfile';

/**
 * Ensures the logged-in user's ffh-backend profile exists before any
 * `PUT /users/me` (or planner) mutation runs on the my-team tabs.
 *
 * `useProfile` runs `GET /users/me` first and, on a 404 (brand-new user),
 * creates the row via `POST /users/me`. The migrated frontend goes straight to
 * the FPL import / build flow without this step, so a user who has never hit
 * the endpoint has no profile and the PUT 404s (PROFILE_NOT_FOUND).
 *
 * Mounting this once inside `MyTeamTabsHOC` mirrors scoreline-app's
 * `ProfileProvider`, which fires the same get-or-create on login before the
 * import is reachable. The fetch is gated on the access token and
 * react-query-cached, so it is a no-op for logged-out visitors and dedupes
 * with the pages that already call `useProfile`.
 */
const ProfileBootstrap = (): null => {
  useProfile();
  return null;
};

export default ProfileBootstrap;
